import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  background: var(--glass-1);
  padding: 40px;
  border-radius: 16px;
  border: 1px solid var(--glass-border);
  backdrop-filter: blur(10px);
  max-width: 600px;
  width: ${props => props.width || '100%'};
  margin: ${props => props.align === 'center' ? '0 auto' : (props.align === 'right' ? '0 0 0 auto' : '0')};
  text-align: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -50px;
    right: -50px;
    width: 150px;
    height: 150px;
    background: radial-gradient(circle, var(--accent-glow) 0%, transparent 70%);
    opacity: 0.3;
    pointer-events: none;
  }
`;

const Title = styled.h2`
  color: var(--text-primary);
  margin: 0 0 10px 0;
  font-size: 24px;
`;

const Sub = styled.p`
  color: var(--text-muted);
  font-size: 14px;
  margin-bottom: 30px;
`;

const InputGroup = styled.div`
  display: flex;
  gap: 10px;
  background: rgba(0,0,0,0.3);
  padding: 6px;
  border-radius: 12px;
  border: 1px solid var(--glass-border);
  box-shadow: inset 0 2px 10px rgba(0,0,0,0.2);

  @media(max-width: 500px) {
    flex-direction: column;
  }
`;

const Input = styled.input`
  flex: 1;
  background: transparent;
  border: none;
  padding: 12px 20px;
  color: #fff;
  font-size: 16px;
  outline: none;

  &::placeholder {
    color: var(--text-muted);
  }
`;

const Button = styled.button`
  background: linear-gradient(135deg, var(--accent), var(--accent-neon));
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0 30px;
  font-weight: bold;
  font-size: 15px;
  cursor: pointer;
  box-shadow: 0 4px 15px var(--accent-glow);

  @media(max-width: 500px) {
    padding: 15px;
  }
`;

const CoverageCheckWidget = ({ node }) => {
  return (
    <Wrapper align={node.style?.desktop?.align} width={node.style?.desktop?.width}>
      <div style={{display:'flex',justifyContent:'center',marginBottom:20}}>
        <svg viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="2" style={{width:48,height:48}}><path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"></path></svg>
      </div>
      <Title>{node.content?.title || '5G Netzabdeckung prüfen'}</Title>
      <Sub>{node.content?.subtitle || 'Geben Sie Ihre Adresse ein, um die O2 Netzqualität an Ihrem Standort zu testen.'}</Sub>
      <InputGroup>
        <Input type="text" placeholder={node.content?.placeholder || 'PLZ, Ort oder Straße'} />
        <Button className="tef-bubbles">{node.content?.btnText || 'Jetzt prüfen'}</Button>
      </InputGroup>
    </Wrapper>
  );
};

registry.register('coverage_check', {
  label: 'Netz Check',
  icon: '📶',
  category: 'tef_specific',
  defaultContent: {},
  defaultStyle: { desktop: { align: 'center', width: '100%' } },
  render: CoverageCheckWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Texte', fields: [{name:'content.title', label:'Titel', type:'text'}, {name:'content.subtitle', label:'Untertitel', type:'textarea'}, {name:'content.placeholder', label:'Platzhalter', type:'text'}, {name:'content.btnText', label:'Button Text', type:'text'}] }] },
    { tab: 'style', groups: [{ title: 'Layout', fields: [{name:'style.desktop.align', label:'Ausrichtung', type:'select', options:[{label:'Zentriert', value:'center'},{label:'Links', value:'flex-start'}]}] }] }
  ]
});
